import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminChannelsChannelRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ channel_id }) {
    const { content } = await this.store.request(
      findRecord('channel', channel_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
